"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSingleFlight = void 0;
/**
 * Runs a task if not already in progress. Otherwise, returns the in-progress promise.
 */
class GlobalSingleFlight {
    flightKey;
    constructor(flightKey) {
        this.flightKey = flightKey;
    }
    run(task) {
        if (this.getInFlightPromise() !== null) {
            return this.getInFlightPromise();
        }
        const promise = (async () => {
            try {
                return await task();
            }
            finally {
                this.setInFlightPromise(null);
            }
        })();
        this.setInFlightPromise(promise);
        return this.getInFlightPromise();
    }
    getInFlightPromise() {
        return global[this.flightKey] ?? null;
    }
    setInFlightPromise(promise) {
        global[this.flightKey] = promise;
    }
}
exports.GlobalSingleFlight = GlobalSingleFlight;
//# sourceMappingURL=GlobalSingleFlight.js.map